import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import markUrl from '../../assets/brand/greeningai-mark.png';

type Props = {
  sx?: SxProps<Theme>;
  className?: string;
};

function readFontSize(sx: SxProps<Theme> | undefined): number | string {
  if (sx && typeof sx === 'object' && !Array.isArray(sx) && 'fontSize' in sx) {
    const size = (sx as { fontSize?: number | string }).fontSize;
    if (typeof size === 'number' || typeof size === 'string') return size;
  }
  return 24;
}

/** Folha GreeningAI. O tamanho continua vindo de `sx.fontSize`. */
export function GreeningIcon({ sx, className }: Props) {
  const size = readFontSize(sx);
  return (
    <Box
      component="img"
      src={markUrl}
      alt=""
      className={className}
      sx={[
        {
          width: size,
          height: size,
          objectFit: 'contain',
          flexShrink: 0,
          display: 'inline-block',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        { width: size, height: size },
      ]}
    />
  );
}

export default GreeningIcon;
